// =============================================================================
// 2026-06-20 (user request "STATUS PROJECT BERBASIS PEKERJAAN, PENAGIHAN &
// RETENSI") — Status operasional project. SATU aturan untuk Summary Project,
// Monitoring, daftar project, filter, dashboard, dan export.
//
// SUMBER KANONIK = field `operational_status` dari backend
// (utils/operational_status.compute_operational_status — disuntikkan di
// GET /active-projects & summary monitoring). Modul ini menyediakan
// label/warna + FALLBACK minimal bila field belum ada; jangan menurunkan
// aturan bisnis di sini (mirror penuh ada di backend agar tidak divergen).
//
// ATURAN: fisik 100% TIDAK otomatis Closed; Closed hanya dari status DB
// eksplisit; tanggal retensi kosong bukan error.
// =============================================================================

export const OP_STATUS_ORDER = [
  "pekerjaan_berjalan",
  "selesai_fisik_administrasi",
  "selesai_fisik_masa_retensi",
  "siap_ditutup",
  "closed",
  "dibatalkan",
];

export const OP_STATUS_META = {
  pekerjaan_berjalan:        { label: "Pekerjaan Berjalan",                  cls: "bg-sky-50 border-sky-300 text-sky-700" },
  selesai_fisik_administrasi:{ label: "Selesai Fisik · Adm/Penagihan",       cls: "bg-amber-50 border-amber-300 text-amber-800" },
  selesai_fisik_masa_retensi:{ label: "Selesai Fisik · Masa Retensi",        cls: "bg-teal-50 border-teal-300 text-teal-700" },
  siap_ditutup:              { label: "Siap Ditutup",                        cls: "bg-emerald-50 border-emerald-300 text-emerald-700" },
  closed:                    { label: "Closed",                              cls: "bg-slate-100 border-slate-300 text-slate-500" },
  dibatalkan:                { label: "Dibatalkan",                          cls: "bg-slate-200 border-slate-400 text-slate-600 line-through" },
};

/** Baca status operasional — backend canonical, fallback minimal tri-raw. */
export function opStatusOf(p, override = null) {
  const op = override || p?.operational_status;
  if (op?.key && OP_STATUS_META[op.key]) return op;
  const raw = (p?.status || "active").toLowerCase();
  if (["cancelled", "cancelled_by_owner"].includes(raw))
    return { key: "dibatalkan", label: OP_STATUS_META.dibatalkan.label, reason: "Project dibatalkan oleh pemberi kerja." };
  if (["completed", "close", "awaiting_payment"].includes(raw))
    return { key: "closed", label: OP_STATUS_META.closed.label, reason: "Ditutup secara eksplisit oleh user berwenang." };
  return { key: "pekerjaan_berjalan", label: OP_STATUS_META.pekerjaan_berjalan.label, reason: "Progress fisik belum 100%." };
}

/** Badge status operasional — tooltip = alasan status (spec user). */
export function OpStatusBadge({ project, override = null, testid, className = "" }) {
  const op = opStatusOf(project, override);
  const meta = OP_STATUS_META[op.key] || OP_STATUS_META.pekerjaan_berjalan;
  return (
    <span
      data-testid={testid || `op-status-${project?.id || "x"}`}
      title={op.reason || meta.label}
      className={`inline-flex items-center px-1.5 py-0.5 text-[9px] font-semibold uppercase tracking-wider border whitespace-nowrap ${meta.cls} ${className}`}
    >
      {meta.label}
    </span>
  );
}
